import { useSelector } from 'react-redux';

export const useUserSelector = () => {
  const user = useSelector((state) => state.user?.selectedChildOffice || state.user?.user);

  return user;
};
